// Контакти пробного: phoneNumber з запису (номер або @нік у Telegram) + botPhone — номер, яким людина поділилась у боті.
// Номер з бота показуємо завжди, коли він інший (у записі часто лише нік) — і в таблиці, і після «Вилучити».

const last9 = (phone) => String(phone || "").replace(/\D/g, "").slice(-9);
const isNick = (value) => /^(@|t\.me\/|https:\/\/t\.me\/)/i.test(String(value || "").trim());

export const formatPhone = (phone) => {
  const digits = String(phone || "").replace(/\D/g, "");
  if (digits.length === 12 && digits.startsWith("380"))
    return `+380 ${digits.slice(3, 5)} ${digits.slice(5, 8)} ${digits.slice(8, 10)} ${digits.slice(10)}`;
  return digits.length >= 10 ? `+${digits}` : String(phone || "");
};

// [{ text, href, fromBot }]
export const trialContacts = (lesson) => {
  const list = [];
  const own = String(lesson.phoneNumber || "").trim();
  if (own) {
    const nick = own.replace(/^(https:\/\/)?t\.me\//i, "@");
    list.push(isNick(own) ? { text: nick, href: `https://t.me/${nick.slice(1)}` } : { text: own, href: `tel:${own.replace(/[^\d+]/g, "")}` });
  }
  if (lesson.botPhone && (isNick(own) || last9(lesson.botPhone) !== last9(own))) {
    const digits = String(lesson.botPhone).replace(/\D/g, "");
    list.push({ text: formatPhone(lesson.botPhone), href: `tel:+${digits}`, fromBot: true });
  }
  return list;
};

export const trialPhonesText = (lesson) =>
  trialContacts(lesson).map(({ text, fromBot }) => (fromBot ? `${text} (з бота)` : text)).join(", ");
